// 주로 백엔드에 보낼 때 사용하는 Flag 변수
export const ROLE_USER = 1
export const ROLE_STORE_MANAGER = 2
export const ROLE_FRANCHISE_MANAGER = 3
export const ROLE_SITE_ADMIN = 4
export const ROLE_STORE_ADMIN = 5
export const ROLE_MARKETING_ADMIN = 6
export const ROLE_EVENT_ADMIN = 7
export const ROLE_SUPER_ADMIN = 8
export const ROLE_EXTERNAL_ADMIN = 9
export const ROLE_FIELD_MANAGER = 10
export const ROLE_TIMER_MANAGER = 11
export const ROLE_COMPETITION_MANAGER = 12

// 주로 백엔드에서 온 값을 출력할 때 사용하는 Object
export const convertRoleAsName = {
	'-1': '미승인',
	1: '사용자',
	2: '지점 매니저',
	3: '프랜차이즈 매니저',
	4: '현장 관리자',
	5: '매장 관리자',
	6: '마케팅 관리자',
	7: '대회 관리자',
	8: '최고 관리자',
	9: '외부 관리자',
	10: '필드 관리자',
	11: '타이머 관리자',
	12: '대회 운영 관리자',
}
